const ImageYoutubeLogo = ({ fillColor }) => {
	return (
		<svg
			version="1.1"
			id="Layer_1"
			pointerEvents="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 68 20"
			style={{ enableBackground: "new 0 0 68 20" }}
			xmlSpace="preserve"
			width="67.2px"
		>
			<desc>Youtube's Logo</desc>
			<path
				className="st0"
				style={{ fill: fillColor }}
				d="M21,5.3c-0.3-0.9-1-1.6-1.9-1.9C17.4,3,10.7,3,10.7,3S4,3,2.3,3.5c-0.9,0.2-1.6,1-1.9,1.9C0,7,0,10.5,0,10.5
	s0,3.5,0.5,5.2c0.2,0.9,1,1.6,1.9,1.9C4,18,10.7,18,10.7,18s6.7,0,8.4-0.5c0.9-0.2,1.6-1,1.9-1.9c0.5-1.7,0.5-5.2,0.5-5.2
	S21.4,7,21,5.3z M8.6,13.7V7.3l5.6,3.2L8.6,13.7z M31.1,16.6c-0.5-0.3-0.8-0.8-0.9-1.3c-0.2-0.6-0.3-1.4-0.3-2.4v-1.4
	c0-1,0.1-1.8,0.3-2.4s0.5-1.1,1-1.3c0.4-0.3,1-0.4,1.7-0.4s1.3,0.1,1.7,0.4s0.8,0.8,0.9,1.3c0.2,0.6,0.3,1.4,0.3,2.4v1.4
	c0,1-0.1,1.8-0.3,2.4s-0.5,1.1-0.9,1.3c-0.4,0.3-1,0.4-1.7,0.4C32.1,17.1,31.5,16.9,31.1,16.6z M33.5,15.2c0.1-0.3,0.2-0.8,0.2-1.5
	v-2.9c0-0.7-0.1-1.2-0.2-1.5s-0.3-0.5-0.6-0.5S32.4,9,32.3,9.3s-0.2,0.8-0.2,1.5v2.9c0,0.7,0.1,1.2,0.2,1.5s0.3,0.5,0.6,0.5
	C33.1,15.6,33.4,15.4,33.5,15.2z M63.6,12.9v0.5c0,0.5,0,0.9,0.1,1.4c0,0.2,0.1,0.5,0.2,0.7c0.1,0.1,0.3,0.2,0.5,0.2
	c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.2-0.7,0.2-1.2l1.8,0.1v0.3c0,0.9-0.2,1.5-0.7,1.9s-1.1,0.6-2,0.6c-1,0-1.8-0.3-2.2-1
	s-0.6-1.7-0.6-3v-1.6c0-1.4,0.2-2.4,0.7-3.1c0.4-0.6,1.2-1,2.2-1c0.7,0,1.3,0.1,1.7,0.4C66.6,8,66.9,8.4,67,8.9
	c0.2,0.6,0.2,1.3,0.2,2.3v1.6L63.6,12.9L63.6,12.9z M63.9,9c-0.1,0.2-0.2,0.4-0.2,0.7c0,0.5-0.1,0.9-0.1,1.4v0.7h1.5V11
	c0-0.5,0-0.9-0.1-1.4c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.1-0.3-0.2-0.5-0.2C64.2,8.8,64,8.8,63.9,9z M25.9,12.8l-2.4-8.7h2.1L26.5,8
	c0.2,1,0.4,1.8,0.5,2.5c0.1-0.5,0.2-1.3,0.5-2.5l0.9-4h2.1L28,12.7v4.2h-2.1V12.8z M42.6,7.5v9.4h-1.7l-0.2-1.1
	c-0.4,0.9-1.1,1.3-2,1.3c-0.6,0-1.1-0.2-1.4-0.6s-0.4-1-0.4-1.9v-7H39v6.9c0,0.3,0,0.6,0.1,0.9c0.1,0.2,0.3,0.3,0.5,0.3
	s0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.3,0.4-0.4V7.5L42.6,7.5z M53.4,7.5v9.4h-1.7l-0.2-1.1c-0.5,0.9-1.1,1.3-2,1.3
	c-0.6,0-1.1-0.2-1.4-0.6s-0.4-1-0.4-1.9v-7h2.1v6.9c0,0.3,0,0.6,0.1,0.9c0.1,0.2,0.3,0.3,0.5,0.3s0.4-0.1,0.5-0.2
	c0.2-0.1,0.3-0.3,0.4-0.4V7.5L53.4,7.5z M48.3,5.8h-2.1V17h-2.1V5.8H42V4.1h6.3L48.3,5.8z M60.4,9c-0.1-0.6-0.3-1-0.6-1.3
	s-0.7-0.4-1.2-0.4c-0.4,0-0.8,0.1-1.1,0.3s-0.6,0.5-0.8,0.9V3.6h-2v13.3h1.7l0.2-0.9c0.2,0.3,0.4,0.6,0.7,0.8s0.7,0.3,1.1,0.3
	c0.7,0,1.2-0.3,1.6-1s0.5-1.7,0.5-3.1v-1.5C60.6,10.7,60.6,9.8,60.4,9z M58.5,12.9c0,0.5,0,1.1-0.1,1.6c0,0.3-0.1,0.6-0.3,0.8
	c-0.1,0.2-0.3,0.3-0.5,0.3s-0.3,0-0.5-0.1s-0.3-0.2-0.4-0.4V9.7c0.1-0.2,0.2-0.5,0.4-0.6c0.1-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.5,0.3
	c0.1,0.3,0.2,0.6,0.2,0.9c0.1,0.6,0.1,1.1,0.1,1.7V12.9z"
			/>
		</svg>
	);
};

export default ImageYoutubeLogo;
